exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.app-container.cookies,\r\n.app-container.cookies main,\r\n.app-container.cookies #main {\r\n    min-height: 0 !important;\r\n    margin-bottom: 0 !important;\r\n    padding-bottom: 0 !important;\n}\n.app-container.cookies .view-container {\r\n    margin-bottom: 0 !important;\r\n    padding-bottom: 0 !important;\n}\n.app-container.cookies .footer-component {\r\n    display: none !important;\n}\r\n", ""]);

// exports
